/**
 * Route for `igaming-chargeback-deduction-from-affiliate-commission`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingChargebackDeductionFromAffiliateCommissionPage } from "../features/igaming-chargeback-deduction-from-affiliate-commission/IgamingChargebackDeductionFromAffiliateCommissionPage";

export const igamingChargebackDeductionFromAffiliateCommissionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-chargeback-deduction-from-affiliate-commission",
	component: IgamingChargebackDeductionFromAffiliateCommissionPage,
});

export default igamingChargebackDeductionFromAffiliateCommissionRoute;
